import React from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import { connect } from "react-redux";
import { onSuccess } from "LIB/submission";
import * as actions from "MODULES/shared/actions/notes";
import {
  form,
  Form as AppForm,
  TextArea
} from "MODULES/shared/components/Forms";

export function Form(props) {
  const { close, handleSubmit, reset } = props;
  const onCancel = () => {
    close();
    reset();
  };
  const submit = onSuccess(handleSubmit, onCancel, props);

  return (
    <AppForm {...props} onSubmit={submit}>
      <AppForm.Body>
        <Field
          name="body"
          component={TextArea}
          label="note"
          required
          autoFocus
        />
      </AppForm.Body>
    </AppForm>
  );
}

Form.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  notesType: PropTypes.string
};

export default connect(undefined, (dispatch, ownProps) => ({
  onSubmit: data =>
    dispatch(
      actions.createNote(
        ownProps.resourceID,
        ownProps.resourceType,
        data,
        ownProps.notesType
      )
    )
}))(
  form({
    form: "createNote"
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/shared/components/Notes/CreateNote/Form.jsx